import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { EditRubricCard } from 'apps/sigma2-ui/src/components/rubrics/EditRubricCard';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { EditRubricCreateButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricCreateButton';
import { EditRubricSelectButton } from 'apps/sigma2-ui/src/components/rubrics/EditRubricSelectButton';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import cn from 'classnames';

interface EditRubricComposableSectionActionButtonsProps {
  onCreate: () => void;
  onSelect: () => void;
  isReadOnlyMode: boolean;
}

interface EditRubricComposableSectionProps
  extends EditRubricComposableSectionActionButtonsProps {
  heading: TranslatedContent;
  subHeading?: TranslatedContent;
  icon?: React.ReactElement<SvgProps>;
  children?: React.ReactNode;
}

const EditRubricComposableSectionActionButtons: React.FC<
  EditRubricComposableSectionActionButtonsProps
> = ({ onCreate, onSelect, isReadOnlyMode }) => {
  if (isReadOnlyMode) {
    return null;
  }

  return (
    <Spacing size="md" direction="horizontal" className="flex-none px-4 py-1">
      <EditRubricCreateButton
        behavior={{
          type: 'onClick',
          onClick: onCreate,
        }}
      />
      <EditRubricSelectButton
        behavior={{
          type: 'onClick',
          onClick: onSelect,
        }}
      />
    </Spacing>
  );
};

export const EditRubricComposableSection: React.FC<
  EditRubricComposableSectionProps
> = (props) => {
  return (
    <EditRubricCard>
      <Spacing size="lg" direction="vertical" className="">
        <Spacing
          size="gap-5"
          direction="horizontal"
          className="items-center justify-between"
        >
          {props.icon && <div className="flex-none">{props.icon}</div>}
          <Spacing
            size="xs"
            direction="vertical"
            className={cn('py-3 flex-grow', { 'pl-2': !props.icon })}
          >
            <S2Typography
              as="h3"
              variant="body-6-bold"
              textColorVariant="gray-1000"
              translatedContent={props.heading}
            />
            {props.subHeading && (
              <S2Typography
                variant="body-7"
                textColorVariant="gray-700"
                translatedContent={props.subHeading}
              />
            )}
          </Spacing>
          <EditRubricComposableSectionActionButtons
            onCreate={props.onCreate}
            onSelect={props.onSelect}
            isReadOnlyMode={props.isReadOnlyMode}
          />
        </Spacing>
        {props.children}
      </Spacing>
    </EditRubricCard>
  );
};
